export default (file) =>
  new Promise((resolve) => {
    const r = new FileReader();
    r.onload = () => {
      resolve(r.result);
    };
    r.readAsArrayBuffer(file);
  });
